module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/95.9d966310.png";